import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
    width: 25%;
    height: 25%;
    max-height: 50px;
    max-width: 50px;
    aspect-ratio: 1/1;
    position: absolute;
    z-index: 9;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;

    ${props => css`
        top: ${props.top}%;
        right: ${props.right}%;
        background-image: url(${props.src});
        transform: rotate(${props.rotate}deg);
    `}
`
